import React, { Component } from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MonthPicker from '../MonthPicker';
import SearchInput from '../SearchInput';
import moment from 'moment-timezone';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import WorkoutNotes from './../WorkoutNotes';
import ProgramNotes from './../ProgramNotes';
import LoadMoreIcon from './../LoadMoreIcon';
import Search from './../workouts/search';
import InfiniteScroll from 'react-infinite-scroll-component';
import { paginationLimit, ConfirmJsMessage, tzStrings } from './../../helpers.js'


/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false,
    startDate: new Date(),
    search: '',
    anchorEl: null,
    assignments: {},
    openWorkout: false,
    openProgram: false,
    selectedWorkout: {},
    selectedProgram: {},
    selectedEmail: '',
    planNotes: [],
    isLoadMoreListing: false
  }


  handleClick = (event, i) => {
    const { assignments } = this.state;
    const temp = [...assignments];
    temp[i].menu = !temp[i].menu;
    this.setState({
      assignments: temp,
      anchorEl: event.currentTarget
    });
  };

  handleClose = (i) => {
    const { assignments } = this.state;
    const temp = [...assignments];
    temp[i].menu = !temp[i].menu;
    this.setState({
      assignments: temp,
      anchorEl: null
    });
  }


  fetchAssigmentDetail = (skip = 0) => {
    if(skip === 0) {
      this.setState({
        assignments: []
      })
    }
    this.props.fetchAsignments({
      params:
      {
        type: this.props.location.pathname.includes('programs') ? 'program' : 
              this.props.location.pathname.includes('automations') ?  'automations' : 'workout',
        search: this.state.search,
        startDate: this.state.startDate,
        limit: paginationLimit.TEN,
        skip: skip
      }
    }).then((data) => {
      let updateData;
      if (this.props.location.pathname.includes('automations')) {
          updateData = data.messages[0]['data'];
      } else {
        updateData = Object.values(data);
      }
      let assignments = updateData
        .map(item => {
          item.menu = false;
          return item;
        });
      if (skip !== 0) {
        assignments = [...this.state.assignments, ...assignments]
      }
     
      this.setState({
        ...this.state,
        dataLoaded: true,
        assignments: assignments,
        isLoadMoreListing:  updateData.length < 10 ? false : true
      })
    });
  };

  componentDidMount() {
    this.setState({ ...this.state, search: '', assignments: [] })
    this.fetchAssigmentDetail();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ ...this.state, search: '', assignments: [] })
      this.fetchAssigmentDetail();
    }
  }


  handleChange = date => {
    this.setState({
      startDate: date
    }, () => {
      this.fetchAssigmentDetail();
    });
  };

  handleSearch = term => {
    this.setState({ ...this.state, search: term }, () => {
      this.fetchAssigmentDetail();
    })
  }

  
  viewWorkoutNotes(item, email, index) {
    const { getPlanNotes  } = this.props;
    this.setState({
      openWorkout: false
    })
    getPlanNotes({
      email,
      workoutId: item._id
    }).then((data) => {
      this.setState({
        openWorkout: true,
        planNotes: data.planNotes,
        selectedWorkout: item
      })
      this.handleClose(index)
    });
  }

  viewProgramNotes(item, email, index) {
    this.setState({
      openProgram: true,
      selectedProgram: item,
      selectedEmail: email
    })
    this.handleClose(index)
  }

  updateStatus(assignmentId, status, index) {
    if (ConfirmJsMessage(`Are you sure you want to ${!status ? 'unassign' : 'assign'} ${this.props.location.pathname.includes('programs') ? 'program' : 'workout'}?`)) {
      const { updateAssignments  } = this.props;
      updateAssignments(assignmentId, status).then((data) => {
        let assignments = this.state.assignments;
        assignments[index]['isAssign'] = status;
        this.setState({
          assignments: assignments
        })
      });
    }
  }
  
 
  render() {
    const { assignments, openWorkout, selectedWorkout, planNotes, selectedEmail, isLoadMoreListing, selectedProgram, openProgram } = this.state;
    const assignmentType  = this.props.location.pathname.includes('programs') ? 'Program' : 'Workout';
    let timeZone;
    if(this.props.user.timeZoneId) {
      const findTz = tzStrings.find((t) => {
        return t.id === this.props.user.timeZoneId
      })
      if(findTz) {
        timeZone = findTz.value;
      }
    }
   
    if (this.state.dataLoaded) {
      return (
        <div>
          <NavigationTabs
            title="Past Assignments"
            subtitle=""
            set="assignments"
            activeRoute={
              this.props.location.pathname.includes('workout') ? "/assignments/workout" : 
              this.props.location.pathname.includes('automations') ? "/assignments/automations" :
              "/assignments/programs"
            } />

          <div className="filter-by-row">
            <h4>Filter By Month</h4>
            <MonthPicker
              selected={this.state.startDate}
              onChange={this.handleChange}
            />
            { this.props.location.pathname.includes('workout') &&
              <Search  label="SEARCH BY EMAIL" changeSearch={this.handleSearch}></Search>
            }
            { this.props.location.pathname.includes('programs') &&
              <Search  label="SEARCH BY EMAIL" changeSearch={this.handleSearch}></Search>
            }
            { this.props.location.pathname.includes('automations') &&
              <Search  label="SEARCH BY EMAIL" changeSearch={this.handleSearch}></Search>
            }
          </div>

          { openWorkout &&
            <WorkoutNotes  workout={selectedWorkout} planNotes={planNotes} />
          }
          {
            openProgram && <ProgramNotes  
              program={selectedProgram} 
              getPlanNotes={this.props.getPlanNotes}
              clientEmail = { selectedEmail } 
              onClose = {
                () => {
                  this.setState({
                    openProgram: false
                  })
                }
              }
            />
          }
          <div
							style={{
								overflow: 'auto',
								height: 400
							}}
							id = "scrollableDiv"
						>
          <InfiniteScroll
                dataLength={assignments.length} //This is important field to render the next data
                next={() => this.fetchAssigmentDetail(assignments.length)}
                hasMore={isLoadMoreListing}
                scrollableTarget="scrollableDiv"
                loader={
                  <LoadMoreIcon/>
                }
              >
          { this.props.location.pathname.includes('automations') ?
            <table className="table">
             {
               assignments.length > 0 &&
               <thead>
                 <tr>
                   <th>Email</th>
                   <th>Message</th>
                   <th>Schedule Date</th>
                   <th style={{ textAlign: 'center' }}>Sent</th>
                 </tr>
               </thead>
             }
             {
               assignments.length === 0 &&
               <tr>
                 <td colSpan="4" style={{ "textAlign": 'center', paddingTop: "20px" }}><h1>No Mesaages</h1></td>
               </tr>
             }
             <tbody>
               
                 {
                   assignments.length > 0 && assignments.map((client, i) => {
                    
                    const cutoffString = moment(client.computeDate).format('YYYY/MM/DD h:mm A')
                   
                     return (
                       <tr key={i} >
                         <td className="email">{client.clientEmail}</td>
                         <td width="300">{client.message}</td>
                         <td>{cutoffString}</td>
                         <td align="center">
                           <img src={client.isSent ? "/assets/img/icon-check-green.png" : "/assets/img/icon-cross-red.png"}
                             width="20px" alt="logo"
                           />
                         </td>
                       </tr>
                     )
                   })
                 }
             </tbody>
            </table>
          :
          <table className="table">
            {
              assignments.length > 0 &&
              <thead>
                <tr>
                  <th>Email</th>
                  <th>{this.props.location.pathname.includes('programs') ? 'Program' : 'Workout'}</th>
                  <th>Date</th>
                  <th style={{ textAlign: 'center' }}>Downloaded</th>
                  <th>Price</th>
                  <th>More</th>
                </tr>
              </thead>
            }
            {
              assignments.length === 0 &&
              <tr>
                <td colSpan="4" style={{ "textAlign": 'center', paddingTop: "20px" }}><h1>No Past Assignments</h1></td>
              </tr>
            }
            <tbody>
              
                {
                  assignments.length > 0 && assignments.map((client, i) => {
                    return (
                      <tr key={i} >
                        <td className="email">{client.clientEmail}</td>
                        {client.workoutId ? (<td>{client && client.workoutId ? client.workoutId.name : ''}</td>) : (<td>{client && client.programId ? client.programId.name : ''}</td>)}

                        <td> {
                           moment(new Date(client.createdAt)).format('MM/DD/YYYY')
                        }</td>
                        <td align="center">
                          <img src={client.isDownloaded ? "/assets/img/icon-check-green.png" : "/assets/img/icon-cross-red.png"}
                            width="20px" alt="logo"
                          />
                        </td>

                        { client.workoutId ?
                          <td>{client.workoutId.price || 'Free'}</td> :
                          <td>{client.programId ?  client.programId.price : 'Free'}</td>
                        }
                        <td>
                          <Button
                            aria-controls="simple-menu"
                            style={{ marginTop: '-10px', marginLeft: '-5px' }}
                            aria-haspopup="true"
                            onClick={event => this.handleClick(event, i)}
                          >
                            More
                            <FontAwesomeIcon icon="chevron-down" style={{ marginLeft: 5 }} />
                          </Button>
                          <Menu
                            id="simple-menu"
                            anchorEl={this.state.anchorEl}
                            open={client.menu}
                            onClose={() => this.handleClose(i)}
                            style={{ boxShadow: 'none' }}
                          >
                            <MenuItem onClick={() => this.handleClose(i)}>
                              <img src={client.isCompleted ? "/assets/img/icon-check-green.png" : "/assets/img/icon-cross-red.png"}
                                width="17px" alt="logo" style={{ marginRight: '10px' }}
                              />Completed
                            </MenuItem>
                          <MenuItem onClick={() => this.handleClose(i)}>
                            <span
                              className="link"
                              onClick={() => this.updateStatus(client._id, client.isAssign ? false : true, i)}
                              style={{ float: 'right' }}>
                             { !client.isAssign ? `Assign ${assignmentType}` : `Unassign ${assignmentType}` }
                            </span>
                          </MenuItem>
                          {(client.workoutId || client.programId) &&
                            <MenuItem>
                            <span
                              className="link"
                              onClick={() => {
                                if(client.type === 'workout' ) {
                                  this.viewWorkoutNotes(client.workoutId, client.clientEmail, i)
                                } else {
                                  this.viewProgramNotes(client.programId, client.clientEmail, i)
                                }
                              }
                              }
                              style={{ float: 'right' }}>
                            {client.isNoteWritten &&
                              <img src={"/assets/img/alert.png"}
                                width="17px" alt="logo" style={{ marginRight: '10px' }}
                              />
                            }
                            View Notes
                            </span>
                            </MenuItem>
                          }
                          </Menu>
                        </td>
                      </tr>
                    )
                  })
                }
            </tbody>
          </table>
           }
          </InfiniteScroll>
          </div>
        </div>

      );
    }
    return null;
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/assignments/List.js